import React, { useState } from 'react';
import { ZapIcon } from 'lucide-react';
import type { CaseStudy } from '../../types/caseStudy';
type CaseStudyCardProps = {
  study: CaseStudy;
};
export function CaseStudyCard({
  study
}: CaseStudyCardProps) {
  const [open, setOpen] = useState(false);
  const panelId = `case-study-${study.id}`;
  return <article className="bg-white rounded-lg shadow-sm border border-gray-100 p-8 md:p-12" data-id="element-221" data-mp="37wy7dm2icef9">
      <img src={study.logo} alt={study.company} className="w-[120px] h-10 object-contain object-left grayscale opacity-80 mb-6" data-id="element-222" data-mp="3locua3zjczrl" />
      <p className="text-sm font-medium text-brand-gray-light mb-3" data-id="element-223" data-mp="3vnk4wjevygb0">
        {study.label}
      </p>
      <h3 className="text-2xl md:text-3xl font-bold text-brand-navy leading-tight mb-5" data-id="element-224" data-mp="3qoharu0g1uht">
        {study.headline}
      </h3>
      <p className="text-lg text-brand-gray leading-relaxed" data-id="element-225" data-mp="218rc0s5e03mr">{study.summary}</p>

      {study.featuredQuote && <figure className="mt-8 border-l-4 border-brand-orange pl-6" data-id="element-226" data-mp="1wbhppldao835">
          <blockquote className="text-lg text-brand-navy italic leading-relaxed" data-id="element-227" data-mp="26ghnnwggakuu">
            "{study.featuredQuote.quote}"
          </blockquote>
          <figcaption className="mt-3 text-base text-brand-gray-light" data-id="element-228" data-mp="2bfua4g3etpww">
            <span className="font-bold text-brand-navy" data-id="element-229" data-mp="2ffv2z5r9a3nh">
              {study.featuredQuote.author}
            </span>
            , {study.featuredQuote.role}
          </figcaption>
        </figure>}

      <button type="button" onClick={() => setOpen(prev => !prev)} aria-expanded={open} aria-controls={panelId} className="mt-8 text-brand-orange font-bold text-lg hover:text-brand-orange-hover transition-colors focus:outline-none focus-visible:underline" data-id="element-230" data-mp="2p5o4fdxop2e0">
        {open ? 'Collapse −' : 'Read the full story +'}
      </button>

      <div id={panelId} aria-hidden={!open} className="grid transition-[grid-template-rows] duration-300 ease-[cubic-bezier(0.23,1,0.32,1)] motion-reduce:transition-none" style={{
      gridTemplateRows: open ? '1fr' : '0fr'
    }} data-id="element-231" data-mp="14rdxcmzb8gab">
        <div className="overflow-hidden" data-id="element-232" data-mp="2c58072cn5om5">
          <div className="pt-10 mt-8 border-t border-gray-100 space-y-10" data-id="element-233" data-mp="2753ij8zzynuc">
            {study.sections.map(section => <div key={section.heading} data-id="element-234" data-mp="2l5mmo51cd9r8">
                <h4 className="text-xl md:text-2xl font-bold text-brand-navy mb-4" data-id="element-235" data-mp="2h2hnabck5o6t">
                  {section.heading}
                </h4>
                <div className="space-y-4" data-id="element-236" data-mp="2v17kdqzdnnv6">
                  {section.paragraphs.map(paragraph => <p key={paragraph} className="text-lg text-brand-gray leading-relaxed" data-id="element-237" data-mp="2q2d3iukz09dp">
                      {paragraph}
                    </p>)}
                </div>
                {section.highlights && <ul className="mt-6 bg-brand-warm-white p-6 md:p-8 rounded-lg border border-gray-100 space-y-5" data-id="element-238" data-mp="3dtiil7j36xmy">
                    {section.highlights.map(highlight => <li key={highlight} className="flex items-start" data-id="element-239" data-mp="3sf64ax4xua7x">
                        <ZapIcon className="w-6 h-6 text-brand-orange mr-4 flex-shrink-0 mt-0.5" data-id="element-240" data-mp="194qigtl92il" />
                        <span className="text-brand-navy font-bold text-lg leading-relaxed" data-id="element-241" data-mp="3jercdexgxwvg">
                          {highlight}
                        </span>
                      </li>)}
                  </ul>}
              </div>)}

            {study.additionalTestimonials.length > 0 && <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-242" data-mp="3egg6ffaao6ii">
                {study.additionalTestimonials.map(testimonial => <div key={testimonial.author} className="bg-brand-light-gray p-8 rounded-lg border-l-4 border-brand-orange flex flex-col h-full" data-id="element-243" data-mp="2zoxi8u7a75o2">
                    <blockquote className="text-brand-navy text-lg leading-relaxed italic mb-6 flex-grow" data-id="element-244" data-mp="2vp6tsx5891mp">
                      "{testimonial.quote}"
                    </blockquote>
                    <div className="mt-auto" data-id="element-245" data-mp="2nqlh1fi0nqvu">
                      <div className="font-bold text-brand-navy" data-id="element-246" data-mp="2ip4ezgnspydo">
                        {testimonial.author}
                      </div>
                      <div className="text-brand-gray-light text-sm mt-1" data-id="element-247" data-mp="2dwuvojh6rwkd">
                        {testimonial.role}
                      </div>
                    </div>
                  </div>)}
              </div>}
          </div>
        </div>
      </div>
    </article>;
}